import NodeDataSource from '../NodeDataSource';
import { useProperties } from 'utils/hooks/useProperties';
import _ from 'lodash';
import { useAssetsFromModelIds } from './SignalFunction';
import { useMemo } from 'react';

/**
 * @typedef {object} PropertyFunctionProps
 * @property {object} [nodes]
 * @property {object[]} properties
 */

/**
 * Function to get properties from an asset. Accepts a list of assets but will only return the properties of the first asset.
 *
 * returns a filterd properties list based on the properties passed in. Values are inserted as desired and reported keys into each property
 * in the assetModel.
 *
 * @param {PropertyFunctionProps} props
 * @returns {object} { asset, isUpdatingProps, updateProps, refetchReported, isLoading, assetModel }
 */
const PropertyFunction =
  ({
    nodes: nodesFromDatasource,
    properties = []
  }) => {
    const { nodes, isLoading: isLoadingNodes } = NodeDataSource({ nodes: nodesFromDatasource });

    const modelIds = _.uniq(_.map(properties, 'modelId'));
    const assets = useAssetsFromModelIds({ nodes, modelIds });
    const chosenAsset = _.first(assets);
    const assetId = chosenAsset?.id;
    // TODO: Select details.modelId when we have removed or decided where modelId should be
    const { asset, isUpdatingProps, updateProps, refetchReported, isLoading, assetModel } = useProperties(
      { assetId, addSuccessAlert: () => {}, addErrorAlert: () => {} });

    const chosenAssetProperties = useMemo(() =>
      _.filter(properties, { modelId: chosenAsset?.modelId ?? chosenAsset?.details?.modelId }),
    [chosenAsset?.details?.modelId, chosenAsset?.modelId, properties]);

    const filteredModel = useMemo(() => {
      const propertyNames = _.map(chosenAssetProperties, 'name');
      const filteredProperties = _.filter(assetModel?.properties, property => _.includes(propertyNames, property.name));
      return { ...assetModel, properties: filteredProperties };
    }, [assetModel, chosenAssetProperties]);
    return { properties: chosenAssetProperties, assetModel: filteredModel, isLoading: isLoading || isLoadingNodes, isUpdatingProps, updateProps, refetchReported, asset };
  };


export default PropertyFunction;
